/** 'block' is reserved by Tiptap, hence the longer name. */
export const BLOCK_NODE_NAME = 'reusable-block';

/** The header row is a link to the snippet, so the text we capture and search leaves it out. */
export const BLOCK_HEADER_ATTR = 'data-block-header';
